module.exports = require("@tronweb3/google-protobuf");